<div
  class="relative isolate flex min-h-dvh flex-col items-center justify-center bg-linear-to-b from-zinc-960 to-zinc-975 px-4 py-12 text-center font-brand text-zinc-100">
  <app-language-switch class="absolute top-4 right-4" />
  <img
    src="./assets/images/logos/incidite-head-white.svg"
    alt="Incidite"
    class="h-6 w-auto" />

  @if (lost()) {
    <h1 class="mt-5 text-[28px] leading-8 tracking-tight text-zinc-50">
      {{ 'pages.auth.code.lost.title' | transloco }}
    </h1>
    <p class="mt-3 max-w-sm text-sm tracking-tight text-zinc-400">
      {{ 'pages.auth.code.lost.description' | transloco }}
    </p>
    <div class="mt-8 flex gap-4 text-13 tracking-tight">
      <a
        class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
        routerLink="/register">
        {{ 'pages.auth.code.lost.register' | transloco }}
      </a>
      <a
        class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
        routerLink="/login">
        {{ 'pages.auth.code.lost.login' | transloco }}
      </a>
    </div>
  } @else {
    <h1 class="mt-5 text-[28px] leading-8 tracking-tight text-zinc-50">
      {{ 'pages.auth.code.title' | transloco }}
    </h1>
    <p class="mt-3 text-sm tracking-tight text-zinc-400" aria-live="polite">
      @if (switchedToLogin()) {
        {{ 'pages.auth.code.existingAccount' | transloco: { email: email() } }}
      } @else {
        {{ 'pages.auth.code.sentTo' | transloco: { email: email() } }}
      }
    </p>

    <app-code-entry
      class="mt-10"
      [step]="step"
      [disabled]="!current()"
      [messages]="messages()"
      (completed)="submit($event)" />

    <app-code-resend
      class="mt-6"
      [resendIn]="cooldown.remaining()"
      [busy]="step.busy()"
      (resend)="resend()"
      (changeEmail)="changeEmail()" />
  }
</div>
